//

class WIP {
    constructor() {
        document.querySelectorAll('[data-wip]').forEach((el) => {
            new WIPItem(this, el)
        });
    }
}

class WIPItem {
    constructor(parent, elment) {
        this.parent = parent
        this.elment = elment
        this.elment.addEventListener('click', this.onClick.bind(this))

        this.title = this.elment.dataset.wipTitle || 'WIP (Work-in-Progress)'
        this.subtitle = this.elment.dataset.wipSubtitle || ''
    }
    onClick(e) {
        e.preventDefault()
        let popup = new Popup()
        popup.setContent(this.title, this.subtitle, '')
        popup.open()

        popup.setLoading(true)
        this.fetch().then((content) => {
            popup.setContent(this.title, this.subtitle, content)
            popup.setLoading(false)
        })
    }
    fetch() {
        return fetch(this.elment.dataset.wip).then((response) => {
            return response.text()
        })
    }
}

class Popup {
    constructor() {
        this.el = document.createElement('div')
        this.el.classList.add('popup')
        this.el.innerHTML = `
            <div class="popup__content">
                <div class="popup__header">
                    <h2 class="popup__title">Title</h2>
                    <h2 class="popup__subtitle">Title</h2>
                    <button class="popup__close"><img src="/img/icons/close.svg?v=1658843002" style="width: 15px; cursor: pointer;"></button>
                </div>
                <div class="popup__body-wrapper">
                    <div class="popup__body">
                    </div>
                </div>
            </div>
        `
        this.el.querySelector('.popup__close').addEventListener('click', this.close.bind(this))

        this.el.addEventListener('submit', (e) => {
            if (!(e.target && e.target.matches('form'))) {
                return
            }

            e.preventDefault()
            const formData = new FormData(e.target);
            const searchParams = new URLSearchParams();

            for (const pair of formData) {
                searchParams.append(pair[0], pair[1]);
            }

            this.setLoading(true)

            fetch(e.target.getAttribute('action'), {
                method: e.target.getAttribute('method'),
                body: searchParams,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
                .then(response => response.text())
                .then(data => {
                    this.setBody(data)
                    this.setLoading(false)
                })
                .catch(error => {
                    console.error('Error:', error)
                    this.setLoading(false)
                });
        })

        this.el.addEventListener('click', (e) => {
            if (!e.target.closest('[data-link]')) {
                return
            }
            e.preventDefault()

            const isOK = confirm('Tem a certeza?')
            if (!isOK) {
                return
            }

            this.setLoading(true)
            fetch(e.target.closest('[data-link]').getAttribute('href'))
                .then(response => response.text())
                .then(data => {
                    this.setBody(data)
                    this.setLoading(false)
                })
                .catch(error => {
                    console.error('Error:', error)
                    this.setLoading(false)
                });

        }, false);

        // if data-link-follow is set, fetch the content and show were
        this.el.addEventListener('click', (e) => {
            if (!e.target.closest('[data-link-follow]')) {
                return
            }
            e.preventDefault()

            this.setLoading(true)
            fetch(e.target.closest('[data-link-follow]').getAttribute('href'))
                .then(response => response.text())
                .then(data => {
                    this.setBody(data)
                    this.setLoading(false)
                })
                .catch(error => {
                    console.error('Error:', error)
                    this.setLoading(false)
                });

        }, false);
    }
    open() {
        document.body.appendChild(this.el)
    }
    close() {
        this.el.remove()
    }
    setContent(title, subtitle, body) {
        this.el.querySelector('.popup__title').innerText = title
        this.el.querySelector('.popup__subtitle').innerText = subtitle
        this.el.querySelector('.popup__body').innerHTML = body
    }
    setBody(content) {
        this.el.querySelector('.popup__body').innerHTML = content
    }
    setLoading(status) {
        if (status) {
            this.el.classList.add('--loading')
        } else {
            this.el.classList.remove('--loading')
        }
    }
}

export default WIP